export const dayJsFormat = () => {
    const dayjs = require('dayjs')
    var relativeTime = require('dayjs/plugin/relativeTime')
    require('dayjs/locale/de')
    dayjs.locale('fr')
    dayjs.extend(relativeTime)
}